<script lang="ts" setup>
import { UIContentWrap } from '@gohighlevel/ghl-ui'
import Postmate from 'postmate'
import { useAppStore } from './store/app'
import { CommonProvider, EmitterKeys } from '@gohighlevel/ghl-proposals-common'
import { useBuilderStore } from './store/builder'
import { useElementOption } from './composable/elementOptions'
import { useI18n } from 'vue-i18n'
import { setSentryMeta } from '@gohighlevel/ghl-proposals-common'
import { useGroups } from './composition'
import { useEmitter } from './composable/useEmitter'

const i18n = useI18n()
const eventBus = useEmitter()

if (process.env.NODE_ENV === 'development') {
  // Postmate.debug = true;
}

const appStore = useAppStore()
const handshake = new Postmate.Model({
  'updated-token': (token: string) => appStore.refreshToken(token),
  'updated-iam-token': (token: string) => appStore.refreshIamToken(token),
  'selected-media-file': (data: any) => {
    eventBus.emit(EmitterKeys.SELECTED_MEDIA_FILE, data)
  },
})
window.getToken = function () {
  return appStore.tokenId
}
window.getAuthToken = function () {
  return appStore.iamToken
}
window.getPostmateHandshake = function () {
  return appStore.handshake
}
handshake.then(async ({ model }: any) => {
  appStore.setupApp({ ...model, handshake })
  setSentryMeta({
    userId: model.userId,
    companyId: model.companyId,
    locationId: '',
    email: model.email,
    locale: model.locale,
  })
  setLocales(model.locale || 'en-US')
})

const setLocales = (lang: string) => {
  let locale = lang
  locale = locale.replace('_', '-')
  const localLang =
    i18n.availableLocales.indexOf(locale) > -1 ? locale : 'en-US'
  localStorage.setItem('locales', localLang)
  i18n.locale.value = localLang
  appStore.updateLocale(localLang)
}
</script>

<template>
  <CommonProvider
    :store-map="{ useAppStore, useBuilderStore }"
    :composition-map="{
      useElementOption,
      useGroups,
    }"
  >
    <UIContentWrap :full-screen="true">
      <!-- <router-view v-if="appStore.tokenId"></router-view> -->
      <router-view />
    </UIContentWrap>
  </CommonProvider>
</template>

<style lang="scss"></style>
